// Owned, AI-generated imagery (no third-party attribution / download requirements).
export const IMG = {
  airportTerminal: "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/56ca0aefbeb4c82bb7180c9e3555ae8e2864de559666d1404a7593d7fa83ee40.jpeg",
  airplaneFlight: "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/6b6cee645e460652ccf7da693814408abc4cae7b0611879751d630020ba48954.jpeg",
  articleA: "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/300dc425d24954ce006901031cdbe7aa7fb557c44f7c8fba79b930890c6c8f01.jpeg",
  articleB: "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/1c0176b6993b7ee3b9e7da3c959285e1388cbdf6dcfbded3d021e56f665eec8a.jpeg",
};

// Owned AI-generated hero backgrounds (rotated randomly per page).
const _P = "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/";
export const AIRLINE_BGS = [
  _P + "258253dbc90b16317ccefc91e8b605f43c2d8f751e004e941c68e4b7c69232b7.jpeg",
  _P + "fc508e61979d3b3e55dfa7631aef9828f8a266c00697db02ed6b24db42e4f076.jpeg",
  _P + "da24159f92cc608c517cd506d3f49c2d13163c18a71af6a78584f11a9325c812.jpeg",
  _P + "d7b5c67f26ef8fc4db07d42044bce93bd322420426f5da766a5922be5a4b260c.jpeg",
  _P + "fd47df2c6224518206fb18af9539981b5bdd40c5435078efaf871f941eaf9a90.jpeg",
  _P + "b652427ac62ee2a86e6d5239fe7135a42963814fb7b04efb32ec946c036dbee1.jpeg",
];
export const AIRPORT_BGS = [
  _P + "7ad7f11cc41a3c7970deee0712fc117ee018113c5c2c770da70822793202455c.jpeg",
  _P + "21224265fd5bbb64d88410c66ed6dc750bf867b30e4d5d66eca26dfb37655e5c.jpeg",
  _P + "7039eda666ca8aa1de418ea7d55b74be4ba1950793bc1be974ad23fdfb6955ba.jpeg",
  _P + "493625887d59a14a87804a6566d8cca5f9c104fe981fbc28de549754021bae9a.jpeg",
  _P + "89ebc77764456b08c0e7e689683067082e7bf7c01ed16ccfe1d0a0786bac1d06.jpeg",
  _P + "f7a0d951dfa0b57e4701426745d29f2cf9cd6d39792e401b72c34227d4a5085b.jpeg",
];

const _hash = (seed = "") => {
  let h = 0;
  for (let i = 0; i < String(seed).length; i++) h = (h * 31 + String(seed).charCodeAt(i)) >>> 0;
  return h;
};
export const pickAirlineBg = (seed = "") => AIRLINE_BGS[_hash(seed) % AIRLINE_BGS.length];
export const pickAirportBg = (seed = "") => AIRPORT_BGS[_hash(seed) % AIRPORT_BGS.length];

// Deterministic header picker for AI profiles (kind: "airline" | "airport").
export const pickHeader = (seed = "", kind = "airline") =>
  (kind === "airport" ? pickAirportBg : pickAirlineBg)(seed);

// Deterministic colorful gradient for IATA/ICAO code badges.
const GRADIENTS = [
  ["#0047FF", "#4F9CFF"],
  ["#FF2B2B", "#FF7A45"],
  ["#7C3AED", "#C084FC"],
  ["#059669", "#34D399"],
  ["#EA580C", "#FBBF24"],
  ["#0891B2", "#22D3EE"],
  ["#DB2777", "#F472B6"],
  ["#4338CA", "#818CF8"],
  ["#B45309", "#FCD34D"],
  ["#15803D", "#4ADE80"],
  ["#BE123C", "#FB7185"],
  ["#1D4ED8", "#38BDF8"],
];
export const codeGradient = (code = "") => {
  let h = 0;
  for (let i = 0; i < code.length; i++) h = (h * 31 + code.charCodeAt(i)) >>> 0;
  return GRADIENTS[h % GRADIENTS.length];
};

// Official airline logo CDN (free) — falls back to badge if the IATA has no logo.
export const airlineLogo = (iata) => (iata && iata.length === 2 ? `https://pics.avs.io/120/120/${iata}.png` : null);

// Brand logos (served from /public).
export const BRAND = {
  horizontal: "/brand-wordmark.png", // brand wordmark — navbar (home) & footer
  round: "/brand-globe.png",         // globe emblem — internal pages & branding
  homePanel: "/brand-hero.webp",     // homepage hero artwork (category cards + icon row)
  innerPanel: "/brand-subpage.webp", // shallow sub-page banner
  full: "/brand-logo-full.webp",     // full logo with tagline — auth page
  masthead: "/brand-logo-tagline.webp", // latest full logo (globe + pulse + tagline, transparent bg) — navbar top of page
};


// Generic travel inspiration photos (owned, AI-generated) — shown as the empty-state gallery
// on city pages until the community uploads real photos.
export const CITY_SEED_PHOTOS = [
  "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/11ce8a2ae48c7160ce40ce5c216b4c5273a904eb405d86efe5aea07da013a904.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/02473f0a78d0f8758e7e1a8e32863bfa32db4375b111f73e00f8ef874befdf2d.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/7712057455beef36d05666edb7432bcc3f57605c796548fc2cead79929d9710a.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/db462b94-64d2-4f35-becf-95e1471a4dcf/images/9e5507cd05a9566cd84828fe9e14e6943c580f85f6f3c37609bd4c3f5ddcf63d.jpeg",
];
